import { Routes } from "@angular/router";

export const errorRoutes: Routes = [
  {
    path: ":errorNumber",
    data: { acceptiableStatuses: ["403", "404"] },
    loadComponent: () => import("./pages/error/error.component").then((c) => c.ErrorComponent),
  },
];
